export enum ServiceName {
  News = 'news',
  Survey = 'survey',
}

export enum MediaStatus {
  READY = 'READY',
  ERROR = 'ERROR',
}

export interface IMediaDropdownOption<T> {
  label: string
  value: number
  name: T
}

export enum Quality {
  QAuto = 'QAuto',
  Q1080p = 'Q1080p',
  Q720p = 'Q720p',
  Q480p = 'Q480p',
  Q360p = 'Q360p',
}

export const qualitiesMap: Record<Quality, IMediaDropdownOption<Quality>> = {
  [Quality.QAuto]: {
    name: Quality.QAuto,
    label: 'Auto',
    value: -1,
  },
  [Quality.Q1080p]: {
    name: Quality.Q1080p,
    label: '1080p',
    value: 1080,
  },
  [Quality.Q720p]: {
    name: Quality.Q720p,
    label: '720p',
    value: 720,
  },
  [Quality.Q480p]: {
    name: Quality.Q480p,
    label: '480p',
    value: 480,
  },
  [Quality.Q360p]: {
    name: Quality.Q360p,
    label: '360p',
    value: 360,
  },
}

export enum Speed {
  Speed05 = 'Speed05',
  Speed1 = 'Speed1',
  Speed15 = 'Speed15',
  Speed2 = 'Speed2',
}

export const speedsMap: Record<Speed, IMediaDropdownOption<Speed>> = {
  [Speed.Speed05]: {
    name: Speed.Speed05,
    label: '0.5x',
    value: 0.5,
  },
  [Speed.Speed1]: {
    name: Speed.Speed1,
    label: '1x',
    value: 1,
  },
  [Speed.Speed15]: {
    name: Speed.Speed15,
    label: '1.5x',
    value: 1.5,
  },
  [Speed.Speed2]: {
    name: Speed.Speed2,
    label: '2x',
    value: 2,
  },
}
